import { Component, HostBinding, Input, OnChanges, OnInit } from "@angular/core";
import { RouteStatus } from "@tms/_enums/RouteStatus";
import { RouteVisitStatus } from "@tms/_enums/RouteVisitStatus";
import { IRouteDetailDisplay } from "@tms/_services/active-routes.service";
import "./active-route-progress.component.scss";

@Component({
    selector: "active-route-progress",
    template: require('./active-route-progress.component.html')
})
export class ActiveRouteProgressComponent implements OnChanges, OnInit {
    @Input() route: IRouteDetailDisplay;
    @Input() autohide: boolean;

    // --

    @HostBinding('class') class = "";
    @HostBinding('class.hide') hide = false;

    progress = 0;

    constructor() {
    }

    ngOnInit(): void {
        this.updateRouteProgress();
    }

    ngOnChanges() {
        this.updateRouteProgress();
    }

    // ---

    private updateRouteProgress() {
        this.updateElementVisibility();
        this.calculateRouteProgress();
        this.updateClasses();
    }

    private updateElementVisibility() {
        if (!this.autohide) {
            return;
        }

        switch (this.route.Status) {
            case RouteStatus.Completed:
            case RouteStatus.Started:
            case RouteStatus.CompletedWithMissing:
            case RouteStatus.Incomplete:
                this.hide = false;
                break;

            default:
                this.hide = true;
        }
    }

    private updateClasses() {

        switch (this.route.Status) {
            case RouteStatus.Cancelled:
            case RouteStatus.Expired:
            case RouteStatus.UserExpired:
            case RouteStatus.Incomplete:
                this.class = "error";
                break;

            case RouteStatus.Completed:
            case RouteStatus.Started:
                this.class = "ok";
                break;

            case RouteStatus.CompletedWithMissing:
                this.class = "warning";
                break;

            default:
                this.class = "";
        }
    }

    private calculateRouteProgress() {
        this.progress = this.tableExportDataDelegate(this.route)
    }

    tableExportDataDelegate(plannedRoute: IRouteDetailDisplay) : number {
        if (!plannedRoute?.PlannedVisits) {
            return 0;
        }

        // Note, this should probably use ETA or distance to show how far through we are
        var progress = 0;

        const numCompletedVisits = plannedRoute.PlannedVisits.filter(v => v.Status == RouteVisitStatus.Arrived || v.Status == RouteVisitStatus.Departed).length;
        progress = Math.round(numCompletedVisits * 100 / plannedRoute.PlannedVisits.length);

        return progress;
    }
}
